import type { FunctionComponent, PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';

const KeyboardShortcutsContext = createContext(true);

type KeyboardShortcutsProviderProps = PropsWithChildren<{
    readonly enabled: boolean;
}>;

export const KeyboardShortcutsProvider: FunctionComponent<KeyboardShortcutsProviderProps> = ({ children, enabled }) => (
    <KeyboardShortcutsContext.Provider value={enabled}>{children}</KeyboardShortcutsContext.Provider>
);

export const useKeyboardShortcutsEnabled = (): boolean => useContext(KeyboardShortcutsContext);
